<div class="oi-page-main">
    <div class="oi-main-dshd">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <h2 class="bg-heading">Knowledge Hub  
              <div class="add-collec-mn"> <span>Add Collection</span>
                <button type="button" class="btn btn-primary" (click)="showAddCollectionModal()"><svg
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23">
                  <g id="Icon_feather-plus" data-name="Icon feather-plus" transform="translate(-6.5 -6.5)">
                    <path id="Path_10" data-name="Path 10" d="M18,7.5v21" fill="none" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="2" />
                    <path id="Path_11" data-name="Path 11" d="M7.5,18h21" fill="none" stroke-linecap="round"
                      stroke-linejoin="round" stroke-width="2" />
                  </g>
                </svg>
              </button>
              </div>
            
            </h2>
          </div>
        </div>
        
     
        
            <div class="row knowcolmsz">
              <div class="col-md-3" *ngFor="let collection of collections">
                <div class="oi-kn-hub-bx1 box d-flex align-items-end flex-column" (click)="fetchdocs(collection.collectionName,collection.collection_id)">
                  <div class="oi-kn-icon-heading">
                    <div class="icon"><img src="../../assets/img/knowledge-icon.png"></div>
                    <h4>{{collection.collectionName}}</h4>
                  </div>

                  <div class="oi-kn-btn-mn mt-auto">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="oi-kn-three-btn">
                          <button type="button" class="btn btn-primary" pTooltip="Upload Document" tooltipPosition="bottom" (click)="uploadDoc($event,collection.collectionName)">
                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg>
                          </button>

                          <button type="button" class="btn btn-primary" pTooltip="Edit Prompt" tooltipPosition="bottom" *ngIf="role=='admin'" (click)="editprompt($event,collection)">
                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor" stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>
                          </button>

                          <button type="button" class="btn btn-primary" pTooltip="View" tooltipPosition="bottom" (click)="fetchdocs(collection.collectionName,collection.collection_id)">
                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" /></svg>
                          </button>
                          <ng-container *ngIf="collectionLoaders[collection.collectionName]">
                            <div class="bx3-img-backdrp drop-loader-txt d-flex align-items-end">
                              <div class="drop-loder-h3">
                              <img src="../../assets/img/loader-line.gif" width="150px">
                              
                            </div>
                            </div>
                          </ng-container>

                        </div>
                      </div>
                     
                    </div>
                  </div>

                </div>
              </div>
           </div>        
        
      </div>
    </div>
</div>
<p-dialog header="Add Collection" [(visible)]="showaddcollection" [style]="{width: '50vw'}" [modal]="true" [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false" (onHide)="onDialogHideaddcollection()">
  <div class="oi-ad-collect-mdl">
    <form [formGroup]="collectionForm" (ngSubmit)="createcollection(collectionForm)">
      <div class="oi-add-collec-field mgtopcollection">
        <div class="row">
          <div class="col-md-6">
            <label>Name</label>
            <input type="text" class="oi-field1 form-control" id="collectionname" placeholder="Name"
              formControlName="collectionname"  [ngClass]="{ 'is-invalid': submitted && f['collectionname'].errors }">
              <div *ngIf="submitted && f['collectionname'].errors" class="invalid-feedback">
                <div *ngIf="f['collectionname'].errors['required']">Name is required</div>
                <div *ngIf="f['collectionname'].errors['minlength']">
                  Name must be at least 3 characters
                </div>
                <div *ngIf="f['collectionname'].errors['maxlength']">
                  Name must not exceed 20 characters
                </div>
              </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="oi-switch">
          <label class="switch">
            <input type="checkbox" formControlName="toggle" >
            <span class="slider round"></span>
          </label>
  
          <div class="oi-switch-text">
            <div *ngIf="f['toggle'].value">
              The collection is available
            </div>
            <div *ngIf="!f['toggle'].value">
             The collection is not available
            </div>
          </div>
  
        </div>
            </div>
            <div class="col-md-12">
              <div class="oi-switch oi-switch1n">

                  <label class="switch">
                      <input type="checkbox" formControlName="enable_similarity_search">
                      <span class="slider round"></span>
                  </label>
                  <div class="oi-switch-text">
                    <div *ngIf="f['enable_similarity_search'].value">
                      The similarity search is enabled
                    </div>
                    <div *ngIf="!f['enable_similarity_search'].value">
                      The similarity search is disabled
                    </div>
                  </div>
              </div>
          </div>
            
               
           </div>
        </div>
        

        <div class="row" *ngIf="collectionType">
          <div class="col-md-12">
            <div class="oi-add-collect-type">
            <label class="add-card-lable">Collection Type</label>
            <div class="oi-select-mn1">
              <p-dropdown [options]="collectionType" formControlName="selectedCollectiontype"
             optionLabel="name" optionValue="name"  placeholder="Select a Type" [ngClass]="{ 'is-invalid': submitted && f['selectedCollectiontype'].errors }"></p-dropdown>
             <div *ngIf="submitted && f['selectedCollectiontype'].errors" class="invalid-feedback">
              <div *ngIf="f['selectedCollectiontype'].errors['required']">Collection Type is required</div>
            </div>
            </div>            
          </div>
          </div>
        </div>
        <div class="row">
          <div class="oi-add-cl-tittle">
          <div class="col-md-12">
            <label>Title</label>
            <input type="text" class="form-control oi-field1" id="title"  placeholder="title"
              formControlName="title"  [ngClass]="{ 'is-invalid': submitted && f['title'].errors }">
              <div *ngIf="submitted && f['title'].errors" class="invalid-feedback">
                <div *ngIf="f['title'].errors['required']">Title is required</div>
                <div *ngIf="f['title'].errors['minlength']">
                  Title must be at least 3 characters
                </div>
                <div *ngIf="f['title'].errors['maxlength']">
                  Title must not exceed 40 characters
                </div>
              </div>
          </div>
          </div>
        </div>
        
                 
        <div class="row">
          
          <div class="col-md-12">
            <div class="oi-add-clt-basetext">
            <label>Base Content</label>
              <textarea id=""  formControlName="BaseContent" class="form-control oi-field1 oi-field1-1" rows="4" cols="50" [ngClass]="{ 'is-invalid': submitted && f['BaseContent'].errors }"></textarea>
              <div *ngIf="submitted && f['BaseContent'].errors" class="invalid-feedback">
                <div *ngIf="f['BaseContent'].errors['required']">Base Content is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="oi-summary-aibtn">
            <label>Summary</label> <span> <button (click)="summaryGeneratewithAI()" class="btn btn-primary" [disabled]="isGenerating"
              [ngClass]="{ 'disabled-button': isGenerating }"><span *ngIf="isGenerating"><i class="fa fa-spinner"></i></span>
              <svg  xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-sparkles"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z" /></svg>              
              Generate with AI</button></span>
    
              <textarea type="text"  class="form-control oi-field1 oi-field1-1" id="tags"  placeholder="Type your Summary"
           formControlName="Summary"  [ngClass]="{ 'is-invalid': submitted && f['Summary'].errors }" rows="4"
            cols="50" > </textarea>
           <div *ngIf="submitted && f['Summary'].errors" class="invalid-feedback">
            <div *ngIf="f['Summary'].errors['required']"> Summary is required</div>
           </div>
        </div>

          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="oi-add-clt-tags">
            <label>Tags</label><span><button (click)="tagGeneratewithAI()" class="btn btn-primary" [disabled]="isloading"
              [ngClass]="{ 'disabled-button': isloading }"> <span *ngIf="isloading">
                <i class="fa fa-spinner"></i>
              </span>
              <svg  xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-sparkles"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z" /></svg> Generate with AI</button></span>
             
              <div class="oi-add-clt-tag-fld">
            <ng-select [items]="tags" [multiple]="true" placeholder="Select tags" formControlName="selectedTag"
              [ngClass]="{ 'is-invalid': submitted && f['selectedTag'].errors }" >
            </ng-select>
            <div *ngIf="submitted && f['selectedTag'].errors" class="invalid-feedback">
              <div *ngIf="f['selectedTag'].errors['required']">Tags required</div>
            </div>
          </div>
            </div>
            </div>

        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="oi-ad-cl-default-prom">
              <label>Default Prompt</label> 
        
              <p-dropdown [options]="DefaultPrompts"
                          [(ngModel)]="selectedPromptValue"
                          optionLabel="template_name"
                          [placeholder]="defaultpromptname ? defaultpromptname : 'Choose your Prompt'"
                          (onChange)="selectedPrompt(selectedPromptValue)"
                          [ngClass]="{ 'is-invalid': submitted && f['DefaultPrompt'].errors }" [ngModelOptions]="{standalone: true}">
                <ng-template let-option pTemplate="item">
                  <div [ngClass]="{'highlight': option.template_code == selectedPromptValue}">
                    {{ option.template_name }}
                  </div>
                </ng-template>
              </p-dropdown>
              <div class="oi-ch-promt-tag1">
                <textarea type="text" class="form-control oi-field1 oi-field1-1"  placeholder="Your prompt" rows="4" cols="50"
                       formControlName="DefaultPrompt" [ngClass]="{ 'is-invalid': submitted && f['DefaultPrompt'].errors }"></textarea>
              </div> 
              <div *ngIf="submitted && f['DefaultPrompt'].errors" class="invalid-feedback">
                <div *ngIf="f['DefaultPrompt'].errors['required']">Prompt is required</div>
              </div>
            </div>
          </div>
        </div>
        

        <div class="row">
          <div class="col-md-12">
            <button type="submit" class="btn btn-default oi-btn1" style="float: right;">Save</button>
          </div>
        </div>      
      </div>
    </form>
  </div>
</p-dialog>
<app-file-upload-modal
  [(visible)]="showuploadmodal"
  [files]="files"
  [uploadLoader]="uploadloader"
  (fileSelected)="handleFileSelection($event)"
  (fileUploaded)="handleFileUpload()"
  (fileDeleted)="handleFileDelete($event)">
</app-file-upload-modal>

<p-dialog header="Default Prompt" [(visible)]="showprompt"  [style]="{width: '50vw'}" [modal]="true"
    [draggable]="false" [resizable]="false" [breakpoints]="{ '960px': '75vw' }" [dismissableMask]="false"
    (onHide)="onHidedefaultPrompt()">
    <div class="oi-ad-collect-mdl khdoc oi-know-bx-height">
        <ng-container *ngIf="modalloader else showdata">
            <div class="loader-knowledge">
                <img src="../../assets/img/loader.gif">
            </div>
        </ng-container>
        <ng-template #showdata>
              <div class="modal-content documnttext df-export-mn">
                <form [formGroup]="editForm">
                    <textarea formControlName="content" class="form-control" [innerHTML]="sanitizeMessage(editForm.value.content)" rows="10" cols="50"></textarea>
                </form>
                <div class="btn-mn-df-ex">
                <button class="btn btn-primary close" (click)="closePrompt()">Close</button>
                <button class="btn btn-primary" (click)="saveChanges()">Save</button>
                </div>
              </div>
        </ng-template>
    </div>
</p-dialog>

<p-toast></p-toast>